import {JobPositionEN} from "./job-position/en";
import {RecordEN} from "./record/en";
import {LaborContractEN} from "./labor-contract/en";
import {WorkplaceConfigEN} from "./work-location/en";
import {EmploymentTypeEN} from "./employment-type/en";
import {categoryEN} from "./category/en";
import {BenefitEN} from "./allowances-type/en";

import {InsuranceConfigEN} from "./insurance/en";
import {GloneEN} from "./level-and-pay-grade/en";
import {JobTitleEN} from "./job-title/en";
import {CompanyRuleEN} from "./company-rules/en";

export const PersonnelSettingEN = {
    ...JobPositionEN,
    ...RecordEN,
    ...LaborContractEN,
    ...InsuranceConfigEN,
    ...WorkplaceConfigEN,
    ...EmploymentTypeEN,
    ...categoryEN,
    ...BenefitEN,
    ...GloneEN,
    ...JobTitleEN,
    ...CompanyRuleEN
}